import { render, staticRenderFns } from "./FieldVariants.vue?vue&type=template&id=4fd22900&scoped=true&"
import script from "./FieldVariants.vue?vue&type=script&lang=js&"
export * from "./FieldVariants.vue?vue&type=script&lang=js&"
import style0 from "./FieldVariants.vue?vue&type=style&index=0&id=4fd22900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd22900",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fd22900')) {
      api.createRecord('4fd22900', component.options)
    } else {
      api.reload('4fd22900', component.options)
    }
    module.hot.accept("./FieldVariants.vue?vue&type=template&id=4fd22900&scoped=true&", function () {
      api.rerender('4fd22900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/form/components/FieldVariants.vue"
export default component.exports